import { Role } from '@/core/components/auth/auth.types'
import { ErrorComponent } from '@/core/components/ErrorComponent'
import { LoadingList } from '@/core/components/LoadingList'
import { redirect } from '@tanstack/react-router'
import { createFileRoute } from '@tanstack/react-router'
import { format } from 'date-fns'
import { z } from 'zod'

const dailyPricingSearchSchema = z.object({
  tab: z.enum(['room', 'activity']).catch('room'),
  startDate: z.string().catch(() => format(new Date(), 'yyyy-MM-dd')),
  endDate: z.string().catch(() => {
    const date = new Date()
    date.setDate(date.getDate() + 14)
    return format(date, 'yyyy-MM-dd')
  }),
  roomId: z.string().optional(),
  rateId: z.string().optional(),
  activityId: z.string().optional(),
})
export const Route = createFileRoute(
  '/_layout/dashboard/sites/$siteId/daily-pricing/'
)({
  validateSearch: (search) => dailyPricingSearchSchema.parse(search),
  beforeLoad: ({ context: { auth } }) => {
    if (auth.isExpired()) {
      return
    }
    if (!auth.isAuthenticated) {
      throw redirect({
        to: '/',
      })
    }
    if (
      auth.user?.role === Role['Front-Desk'] ||
      auth.user?.role === Role['Blogger']
    ) {
      throw redirect({
        to: '/dashboard',
      })
    }
  },
  pendingComponent: LoadingList,
  errorComponent: ErrorComponent,
})
